import { Button, ColorInput, FormField, Loader, Text } from '@wix/design-system';
import { InstanceData } from '../models/shared/InstanceData';
import { UPGRADE_LINK } from '../utils/shared/constants';
import { ChevronRight, Star } from '@wix/wix-ui-icons-common';
import { useSettingsContext } from '../context/SettingsContext';

interface Props {
    instanceData: Partial<InstanceData>

}

export default function BusinessSettings(props: Props) {
    const { settings, updateSettings, processing } = useSettingsContext();
    const hasBusinessPlan = props.instanceData.vendorProductId && ['business', 'enterprise', 'friend'].includes(props.instanceData.vendorProductId);
    const { navigate } = useSettingsContext();

    return (
        <>
            <hr />
            <div className='section d-flex flex-column gap-2'>

                <Text skin='premium'>Premium Settings</Text>

                {!hasBusinessPlan && <>
                    <Text size='tiny'>These settings are available only for Business and Enterprise plans</Text>
                    <a href={`${UPGRADE_LINK}${props.instanceData.instanceId}`} target='_blank' rel='noreferrer'>
                        <Button prefixIcon={<Star />} skin='premium'>Upgrade To Enable</Button>
                    </a>
                </>}
            </div>

            <div className='section'>
                <FormField label="Text Color" suffix={processing && <Loader size='tiny' />}
                    infoContent='Choose a text color for the review boxes'
                >
                    <ColorInput
                        popoverPlacement='bottom-end'
                        value={settings?.textColor || ''}
                        onConfirm={(color) => updateSettings({ textColor: color + '' })}
                        disabled={!hasBusinessPlan}
                    />
                </FormField>
            </div>

            <div className='section'>
                <FormField label="Background Color" suffix={processing && <Loader size='tiny' />}
                    infoContent='Choose a background color for the review boxes'
                >
                    <ColorInput
                        popoverPlacement='bottom-end'
                        value={settings?.backgroundColor || ''}
                        onConfirm={(color) => updateSettings({ backgroundColor: color + '' })}
                        disabled={!hasBusinessPlan}
                    />
                </FormField>
            </div>

            <div className='section'>

                <Button
                    priority='secondary'
                    disabled={!hasBusinessPlan}
                    suffixIcon={<ChevronRight />}
                    onClick={() => navigate('manageReviews')}
                >
                    Manage Reviews
                </Button>

            </div>
        </>
    )
}
